<template>
    <v-container fluid class="container-admin-control">
        <v-layout md1 pd1 mb-4>
            <v-card dark width="100%" class="card">
                <v-card-title>
                <v-flex lg3 md1 style="font-size:26px;" class="text-xs-left">
                    <span>iLog Management</span>
                </v-flex>
                <!-- <v-spacer /> -->
                </v-card-title>
            </v-card>
        </v-layout>
        <v-layout justify-start column fill-height mb-4>
            <v-tabs class="tabs" v-model="tabIndex" color="dark" dark>
                <v-tabs-slider color="yellow" />
                <v-tab
                    v-for="item in tabMenu"
                    :key="item.id"
                    style="text-transform: capitalize;">
                    <v-icon size="18" style="margin-right: 3px;">
                        {{ item.icon }}
                    </v-icon>
                    <span>
                        {{ item.title }}
                    </span>
                </v-tab>
                <v-tabs-items v-model="tabIndex">
                    <customerDetail v-if="tabIndex == 0" />
                    <allDashboard v-if="tabIndex == 1" />
                    <generateUser v-if="tabIndex == 2" />
                    <pdpaControl v-if="tabIndex == 3" />
                    <eventControl v-if="tabIndex == 4" />
                    <monitor v-if="tabIndex == 5" />
                    <monitorVolume v-if="tabIndex == 6" />
                </v-tabs-items>
            </v-tabs>
        <!-- <router-view /> -->
      </v-layout>
    </v-container>
</template>
<script>
// import axios from 'axios'
import jwtDecode from 'jwt-decode'
import generateUser from '@/views/generateUser'
import customerDetail from '@/views/customerDetail'
import allDashboard from '@/views/alldashboard'
import pdpaControl from '@/views/pdpaControl'
import eventControl from '@/views/eventControl'
import monitor from '@/views/monitor'
import monitorVolume from '@/views/monitorVolume'
export default {
    name: 'adminControl',
    components: {
        generateUser,
        customerDetail,
        allDashboard,
        pdpaControl,
        eventControl,
        monitor,
        monitorVolume
    },
    data () {
        return {
            item: '',
            tabIndex: 0,
            tabMenu: [
                {
                    title: 'Customer Detail',
                    icon: 'people'
                },
                {
                    title: 'All Dashboard',
                    icon: 'edit'
                },
                {
                    title: 'Generate User',
                    icon: 'group_add'
                },
                {
                    title: 'PDPA',
                    icon: 'fact_check'
                },
                {
                    title: 'Event',
                    icon: 'event_available'
                },
                {
                    title: 'Monitor Docker',
                    icon: 'access_alarm'
                },
                {
                    title: 'Monitor Disk',
                    icon: 'access_alarm'
                }
            ],
            token: '',
            username: '',
            ampid: ''
        }
    },
    created () {
        this.token = sessionStorage.getItem('user-token')
        let decoded = jwtDecode(this.token)
        this.ampid = decoded.ampid
        this.username = decoded.username
    },
    // methods: {
    //     updateRouter (val) {
    //         this.$router.push(val)
    //     }
    // },
    watch: {
        tabIndex: function () {
            window.analytics.track(`[Administrator][${this.tabMenu[this.tabIndex].title}]`, {},
            {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
        }
    }
}
</script>
<style scoped>
.container-admin-control {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 60px;
}

.card {
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminControl.vue